var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner'),_vm._v(" "),_c('div',{staticClass:"ywlx"},[_c('p',[_vm._v("请选择业务角色")]),_vm._v(" "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.link(2)}}},[_vm._v("法人")]),_vm._v(" "),_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.link(1)}}},[_vm._v("自然人")])],1),_vm._v(" "),_c('tabbar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0d0035c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/yw.vue
// module id = null
// module chunks = 